export default {
  ORDER_CANCEL_TYPE: {
    1: '用户已取消订单',
    2: '用户超时未付款',
    3: '无货',
    4: '订购人与支付人不一致',
    5: '订单金额不一致',
    6: '未发货后台取消',
    7: '订单申请全额退款',
    20: '其他',
  },
  // 商品状态1未上架 2 出售中 3仓库中
  GOODS_STATUS: {
    onShelves: 2,
    offShelves: 3,
  },
};
